import {
  nonNegativePriceInputDisplayValue,
  parseNonNegativePriceInput,
  shouldBlockNonNegativePriceKey,
} from '../utils/nonNegativePriceInput';

export type NonNegativePriceInputProps = {
  id: string;
  value: number | null | undefined;
  onChange: (price: number | null) => void;
  className?: string;
};

export function NonNegativePriceInput({
  id,
  value,
  onChange,
  className,
}: NonNegativePriceInputProps) {
  return (
    <input
      id={id}
      type="number"
      inputMode="decimal"
      min={0}
      step="any"
      className={className}
      value={nonNegativePriceInputDisplayValue(value)}
      onChange={(event) => {
        const raw = event.target.value;
        if (raw === '') {
          onChange(null);
          return;
        }
        if (raw.startsWith('-')) {
          return;
        }
        const parsed = parseNonNegativePriceInput(raw);
        if (parsed === null && raw.trim() !== '') {
          return;
        }
        onChange(parsed);
      }}
      onKeyDown={(event) => {
        if (shouldBlockNonNegativePriceKey(event.key)) {
          event.preventDefault();
        }
      }}
    />
  );
}
